import { Briefcase, TrendingUp } from "lucide-react";

const openings = [
  { role: "Data Science", detail: "8 Openings", pkg: "Up to 12 LPA" },
  { role: "AI Engineer", detail: "6 Openings", pkg: "Up to 18 LPA" },
  { role: "Cyber Security Analyst", detail: "10 Openings", pkg: "Up to 14 LPA" },
  { role: "KPMG", detail: "5 Openings at KPMG", pkg: "Up to 24 LPA" },
  { role: "Cloud Engineer", detail: "4 Openings", pkg: "Up to 15 LPA" },
];

const OpeningsMarquee = () => (
  <div style={{ background: "var(--bg-secondary)", borderBottom: "1px solid var(--input-border)" }} data-testid="openings-marquee">
    <div className="max-w-6xl mx-auto px-5 h-11 flex items-center gap-4 overflow-hidden">
      <span className="shrink-0 inline-flex items-center gap-2 text-xs sm:text-sm font-bold whitespace-nowrap" style={{ color: "var(--accent)" }} data-testid="marquee-label">
        <Briefcase size={14} />
        Job Openings This Week
      </span>
      <span className="w-px h-5 shrink-0" style={{ background: "var(--input-border)" }} />
      <div className="marquee marquee-fade flex-1 overflow-hidden">
        <div className="marquee-track">
          {[...openings, ...openings].map((o, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1 text-xs whitespace-nowrap"
              style={{ background: "var(--bg-card)", border: "1px solid var(--input-border)" }}
              data-testid={`marquee-item-${i % openings.length}`}
            >
              <TrendingUp size={12} style={{ color: "var(--accent)" }} />
              <span className="font-semibold text-white">{o.role}</span>
              <span style={{ color: "var(--text-muted)" }}>·</span>
              <span style={{ color: "var(--text-body)" }}>{o.detail}</span>
              <span style={{ color: "var(--text-muted)" }}>·</span>
              <span className="font-semibold" style={{ color: "var(--accent)" }}>{o.pkg}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const Header = ({ onCta }) => (
  <div className="sticky top-0 z-40">
    <div style={{ background: "var(--bg-secondary)", borderBottom: "1px solid var(--input-border)" }} data-testid="top-bar">
      <div className="max-w-6xl mx-auto px-5 py-2 flex items-center justify-between gap-3">
        <span className="flex items-center gap-2.5 min-w-0">
          <img src="/images/logo.png" alt="Institute logo" className="w-7 h-7 rounded-md object-cover shrink-0" style={{ border: "1px solid var(--input-border)" }} data-testid="header-logo" />
          <span className="text-xs sm:text-sm truncate" style={{ color: "var(--text-body)" }} data-testid="top-bar-text">
            <span className="font-semibold" style={{ color: "var(--accent)" }}>New Batch Starting Soon</span>
            <span className="hidden sm:inline"> — Limited Seats, Personal Guidance</span>
            <span className="sm:hidden"> — Limited Seats</span>
          </span>
        </span>
        <button
          data-testid="topbar-inquire-button"
          onClick={onCta}
          className="cta-button shrink-0 text-xs font-bold rounded-full px-3.5 py-1"
        >
          Inquire Now
        </button>
      </div>
    </div>
    <OpeningsMarquee />
  </div>
);
